import normalize from 'components/Dashboard/utilities/normalizeString';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useMainSectionParameter } from 'components/Dashboard/helpers/useMainSectionParameter';

const ParliamentaryRecordMultipleHierarchy = (props) => {
  const { filter, selectOption, notIncludeName } = props;
  const { name, options } = filter;
  const params = useParams();
  const { inboxSection } = useMainSectionParameter(params);

  const thirdLevelOptions = (secondLevelItem) => secondLevelItem.nestedOptions ?? secondLevelItem.options;

  const fillNestedSelectionsForOption = (regionOption) => {
    regionOption.options.forEach((item) => {
      const nested = thirdLevelOptions(item);
      if (nested?.length) {
        item.selectedNestedOptions = nested.map((n) => n.name);
      }
    });
  };

  const clearNestedSelectionsForOption = (regionOption) => {
    regionOption.options.forEach((item) => {
      if (item.selectedNestedOptions) {
        item.selectedNestedOptions = [];
      }
    });
  };

  const changeFilter = ({ option, suboption, nestedSuboption, index, parentIndex, customOption }) => {
    let newValue = JSON.parse(JSON.stringify(options));

    if (option) {
      let newOption = newValue[index];
      let selectedStatus = newOption.selected;
      newOption.selected = !selectedStatus;
      if (selectedStatus) {
        newOption.selectedOptions = [];
        clearNestedSelectionsForOption(newOption);
        if (newOption.houseFilter) {
          newOption.houseFilterSelectedOptions = [];
        }
      } else {
        if (newOption.houseFilter) {
          newOption.houseFilterSelectedOptions = newOption.houseFilter.options.map((item) => item.name);
        }
        newOption.selectedOptions = newOption.options.map((item) => item.name);
        fillNestedSelectionsForOption(newOption);
      }
    }

    if (nestedSuboption) {
      let newOption = newValue[parentIndex];
      const secondLevel = newOption.options[index];
      if (!newOption.selected) {
        newOption.selected = true;
      }
      if (newOption.houseFilterSelectedOptions?.length === 0 && newOption.houseFilter) {
        newOption.houseFilterSelectedOptions = newOption.houseFilter.options.map((item) => item.name);
      }
      if (!secondLevel.selectedNestedOptions) {
        secondLevel.selectedNestedOptions = [];
      }
      const nestedName = nestedSuboption.name;
      if (secondLevel.selectedNestedOptions.includes(nestedName)) {
        secondLevel.selectedNestedOptions.splice(secondLevel.selectedNestedOptions.indexOf(nestedName), 1);
      } else {
        secondLevel.selectedNestedOptions.push(nestedName);
      }
      if (!newOption.selectedOptions.includes(secondLevel.name)) {
        newOption.selectedOptions.push(secondLevel.name);
      }
      if (secondLevel.selectedNestedOptions.length === 0) {
        const secondLevelNameIndex = newOption.selectedOptions.indexOf(secondLevel.name);
        if (secondLevelNameIndex !== -1) {
          newOption.selectedOptions.splice(secondLevelNameIndex, 1);
        }
      }
      if (newOption.selectedOptions.length === 0) {
        newOption.selected = false;
        if (newOption.houseFilter) {
          newOption.houseFilterSelectedOptions = [];
        }
      }
    }

    if (suboption || customOption) {
      let newOption = newValue[parentIndex];

      if (!newOption.selected) {
        newOption.selected = true;
      }
      if (customOption && newOption.selectedOptions.length === 0) {
        newOption.selectedOptions = newOption.options.map((item) => item.name);
        fillNestedSelectionsForOption(newOption);
      }
      if (suboption && newOption.houseFilterSelectedOptions?.length === 0) {
        newOption.houseFilterSelectedOptions = newOption.houseFilter.options.map((item) => item.name);
      }

      let newSuboption = customOption ? newOption.houseFilter.options[index] : newOption.options[index];
      let param = customOption ? 'houseFilterSelectedOptions' : 'selectedOptions';
      let selectedOptionsList = newOption[param];

      if (suboption && !customOption && thirdLevelOptions(newSuboption)?.length) {
        const optionName = newSuboption.name;
        if (selectedOptionsList.includes(optionName)) {
          const position = selectedOptionsList.indexOf(optionName);
          selectedOptionsList.splice(position, 1);
          newSuboption.selectedNestedOptions = [];
          if (selectedOptionsList.length === 0 && newOption.houseFilterSelectedOptions) {
            newOption.houseFilterSelectedOptions = [];
          }
          if (selectedOptionsList.length === 0) {
            newOption.selected = false;
          }
        } else {
          selectedOptionsList.push(optionName);
          newSuboption.selectedNestedOptions = thirdLevelOptions(newSuboption).map((n) => n.name);
        }
      } else if (suboption || customOption) {
        let optionName = newSuboption.name;
        if (selectedOptionsList.includes(optionName)) {
          let position = selectedOptionsList.indexOf(optionName);
          if (suboption || (customOption && selectedOptionsList.length === newOption?.houseFilter?.options.length)) {
            selectedOptionsList.splice(position, 1);
          }

          if (suboption) {
            if (thirdLevelOptions(newSuboption)?.length) {
              newSuboption.selectedNestedOptions = [];
            }
            //Deselect houseFilter when no options are selected
            if (selectedOptionsList.length === 0 && newOption.houseFilterSelectedOptions) {
              newOption.houseFilterSelectedOptions = [];
            }
          }
        } else {
          selectedOptionsList.push(optionName);
          if (suboption && thirdLevelOptions(newSuboption)?.length) {
            newSuboption.selectedNestedOptions = thirdLevelOptions(newSuboption).map((n) => n.name);
          }
        }
        if (selectedOptionsList.length === 0 && suboption) {
          newOption.selected = false;
        }
      }
    }
    selectOption({ filter, newValue });
  };

  return (
    <>
      {!notIncludeName && <h3>{name}</h3>}
      <div className={`common-outside-filter ${inboxSection ? 'common-outside-filter-inbox' : ''}`}>
        {options.map((option, index) => {
          const { name, disabled, options, selected, selectedOptions, houseFilter, houseFilterSelectedOptions } =
            option;
          const identifier = `checkbox-item-${normalize(name)}-${filter.name}-${index}`;
          return (
            <React.Fragment key={identifier}>
              <div className={`filter-item-container`} key={identifier}>
                <div
                  className={`checkbox-item filter-item-${normalize(name)} ${disabled ? 'checkbox-item-disabled' : ''}`}
                >
                  <input
                    id={identifier}
                    onChange={() => {
                      changeFilter({ option, index });
                    }}
                    type={`checkbox`}
                    disabled={disabled}
                    checked={selected}
                  />
                  <label htmlFor={identifier}>{name}</label>
                </div>
              </div>
              {houseFilter && (
                <div className='d-flex box-rounded custom-filter-house'>
                  {houseFilter.options.map((houseFilter, customIndex) => {
                    const identifier = `custom-filter-${normalize(houseFilter.name)}`;
                    return (
                      <div className={`p-2 ${identifier}-container`} key={identifier}>
                        <div className={`checkbox-item flex-grow-1 my-0 filter-item-${normalize(houseFilter.name)}`}>
                          <input
                            id={identifier}
                            onChange={() => {
                              changeFilter({ parentIndex: index, customOption: houseFilter, index: customIndex });
                            }}
                            type={`checkbox`}
                            disabled={disabled}
                            checked={houseFilterSelectedOptions.includes(houseFilter.name)}
                          />
                          <label className={`mb-0 ${identifier}`} htmlFor={identifier}>
                            {houseFilter.name}
                          </label>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              <div className='indented-filters parliamentary-hierarchy-filter'>
                {options.map((optionItem, optionIndex) => {
                  const { name, selectedNestedOptions = [] } = optionItem;
                  const nestedTier = thirdLevelOptions(optionItem);
                  const identifier = `${normalize(option.name)}-${optionIndex}-${normalize(name)}`;
                  const hasNestedSuboptions = nestedTier?.length > 0;
                  return (
                    <React.Fragment key={identifier}>
                      <div className={`checkbox-item filter-item-${normalize(option.name)}`}>
                        <input
                          id={identifier}
                          onChange={() => {
                            changeFilter({ parentIndex: index, suboption: optionItem, index: optionIndex });
                          }}
                          type={`checkbox`}
                          disabled={disabled}
                          checked={selectedOptions.includes(name)}
                        />
                        <label htmlFor={identifier}>
                          <span className='label-name'>{name}</span>
                        </label>
                      </div>
                      {hasNestedSuboptions && (
                        <ul className='policy-list filters-indented-list mb-0 pb-0 nested-suboptions-list'>
                          {nestedTier.map((nestedItem, nestedIndex) => {
                            const nestedId = `${identifier}-nested-${nestedIndex}-${normalize(nestedItem.name)}`;
                            return (
                              <li
                                className={`checkbox-item ${
                                  nestedIndex < nestedTier.length - 1 ? 'mb-2' : ''
                                } filter-item-${normalize(nestedItem.name)}`}
                                key={nestedId}
                              >
                                <input
                                  id={nestedId}
                                  onChange={() => {
                                    changeFilter({
                                      parentIndex: index,
                                      index: optionIndex,
                                      nestedSuboption: nestedItem,
                                    });
                                  }}
                                  type='checkbox'
                                  disabled={disabled}
                                  checked={selectedNestedOptions.includes(nestedItem.name)}
                                />
                                <label htmlFor={nestedId}>
                                  <span className='label-name'>{nestedItem.name}</span>
                                </label>
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
};

export default ParliamentaryRecordMultipleHierarchy;
